// extracted by mini-css-extract-plugin
module.exports = {"Card":"user-statistic-live-orders_Card__3NqFF","Pagination":"user-statistic-live-orders_Pagination__1s9iW"};